import { InventoryType } from "../store/data/types";
import { api } from "./api";
import { retryApiRequest } from "./api.utils";
import { endpoints } from "./endpoints";
import { errorMessages } from "@/global/config/errorMessages";

const refreshInventoryApi = process.env.NODE_ENV === "development" ? "http://localhost:5004/inventory/refreshInventory" : "https://adminbackend.seasonshare.com/inventory/refreshInventory"; // prettier-ignore

export async function getEventFiltersApi(payload: { teamSchema: string }) {
  return await api.post(endpoints.getEventFilters, payload);
}

export async function getInventoryFiltersApi(payload: {
  teamSchema: string;
  eventCode: string;
  isAda: boolean;
  seatCount?: number;
}) {
  return await api.post(endpoints.getInventoryFilters, payload);
}

export async function getInventoryApi(payload: {
  teamSchema: string;
  eventCode: string;
  inventoryType: InventoryType["inventoryType"];
  inventoryFilters: {
    seatCount: number;
    priceRange: number[] | null[];
    sectionNames: string[];
  };
}) {
  return await api.post(endpoints.getInventory, payload);
}

export async function manageCartApi(payload: {
  teamSchema: string;
  cart: {
    eventCode: string;
    products: InventoryType[];
  }[];
}) {
  return await api.post(endpoints.manageCart, payload);
}

export async function cancelCartApi(payload: {
  teamSchema: string;
  cartId: number;
  seatLocations: string[];
  serviceFeeLocations?: string[];
  perkLocations?: string[];
}) {
  return await api.post(endpoints.cancelCart, payload);
}

export async function refreshEvent(payload: {
  teamSchema: string;
  eventCode: string;
}) {
  return await api.post(refreshInventoryApi, payload);
}

export async function manageCartForSimilarSeatsApi(payload: {
  teamSchema: string;
  products: InventoryType[];
  events: { eventCode: string; seatCount: number }[];
}) {
  // creating the fetcher function
  const fetcher = async <T = any>(payload: T) => {
    return await api.post(endpoints.manageCartForSimilarSeats, payload);
  };
  // calling the fetcher with retry
  const res = await retryApiRequest(fetcher, {
    payload,
    status: 202,
    delay: 2000,
    nextReqDataKey: "jobId",
    retryLimit: 15,
  });
  // after retrying, if the status is still 202, throw an error
  if (res.status == 202) throw new Error(errorMessages.default);
  // otherwise, return the response
  return res;
}

export async function getPreviewInventoryApi(payload: {
  teamSchema: string;
  eventCode: string;
  inventoryType: string;
  accountGroup: number;
  inventoryFilters: {
    sectionNames: string[];
  };
}) {
  return await api.post(endpoints.getPreviewInventory, payload);
}

export async function getPacksMappingApi(payload: { teamSchema: string }) {
  return await api.post(endpoints.getPacksMapping, payload);
}
